import type { FaireProductEntity } from "../../entity_types/product";

export const p_fsxn9d3hjh: FaireProductEntity = {
  token: "p_fsxn9d3hjh",
  type: "product",
  name: "Palo Santo 8 oz. Candle",
  brandToken: "b_ambzy6ccke",
  brandName: "Night Blooms Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/dba6d4e612c833ef49016d8d94dc853da91d259cadaea7b5676b1b5850ab1c63.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7daadd4d6b56bfa46f1ada4b8c0e63b05f84e71d76ba2ba9b37512f4197f44c5.png",
  ],
  priceDollars: 21,
  description:
    "Deeply complex and aromatic, Palo Santo is a scent for ritual and renewal. Grounding and sacred, we’ve captured the essence of freshly lit palo santo—warm, resinous, and laced with soft smoke. Rich wood and golden amber deepen the aroma, creating a meditative space that clears the air and invites intention.\n\n• 100% natural soy wax\n• Non-toxic + phthalate free\n• Braided cotton wick\n• Ceramic screen printed labels (Reuse this glass)\n• Extended burn 50+ hours\n• Hand poured in Ojai, California",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:53.779Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
